/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloudAccountPartialUpdate
 */
export interface CloudAccountPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof CloudAccountPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountPartialUpdate
     */
    provider?: CloudAccountPartialUpdateProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountPartialUpdate
     */
    accessId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountPartialUpdate
     */
    secret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountPartialUpdate
     */
    tenant?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountPartialUpdate
     */
    subscription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountPartialUpdate
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountPartialUpdate
     */
    mountCredentialsManagement?: CloudAccountPartialUpdateMountCredentialsManagementEnum;
}

/**
* @export
* @enum {string}
*/
export enum CloudAccountPartialUpdateProviderEnum {
    Azure = 'azure',
    Aws = 'aws',
    Backblaze = 'backblaze',
    Gcloud = 'gcloud'
}/**
* @export
* @enum {string}
*/
export enum CloudAccountPartialUpdateMountCredentialsManagementEnum {
    Null = 'null',
    Share = 'share',
    Token = 'token'
}

export function CloudAccountPartialUpdateFromJSON(json: any): CloudAccountPartialUpdate {
    return CloudAccountPartialUpdateFromJSONTyped(json, false);
}

export function CloudAccountPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudAccountPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'accessId': !exists(json, 'access_id') ? undefined : json['access_id'],
        'secret': !exists(json, 'secret') ? undefined : json['secret'],
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'mountCredentialsManagement': !exists(json, 'mount_credentials_management') ? undefined : json['mount_credentials_management'],
    };
}

export function CloudAccountPartialUpdateToJSON(value?: CloudAccountPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'provider': value.provider,
        'access_id': value.accessId,
        'secret': value.secret,
        'tenant': value.tenant,
        'subscription': value.subscription,
        'endpoint': value.endpoint,
        'mount_credentials_management': value.mountCredentialsManagement,
    };
}


